import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/internal/Observable";
import { TelehealthConsentHistory } from "src/app/models/telehealth-consent-history.model";
import { ApiService } from "../api.service";
import { BaseService } from "./base.service";

@Injectable({
    providedIn: 'root'
  })
  export class TelehealthConsentHistoryService extends BaseService {

    constructor (
      protected apiService: ApiService,
      protected http: HttpClient
    ) {
      super(apiService, http, 'telehealth-consent-history');


    }

  create(tele: FormData) {
    return this.http.post<TelehealthConsentHistory>(`${this.apiUrl}`, tele);
  }

  getByExamId(examId: number): Observable<TelehealthConsentHistory> {
    return this.http.get<TelehealthConsentHistory>(`${this.apiUrl}/exam/${examId}`);
  }

}
